import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SortInfo, SortOption } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'digihaven-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['./table-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeaderComponent {
    @Input() title!: string;
    @Input() sortOptions?: SortOption[];
    @Input() condensed = false;
    @Output() sortInfoChanged: EventEmitter<SortInfo | undefined> = new EventEmitter();

    onSortInfoChange(sortInfo: SortInfo | undefined): void {
        this.sortInfoChanged.next(sortInfo);
    }
}
